var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTotaldrivers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.125 31.5C34.125 27.1508 37.6507 23.625 42 23.625C46.3492 23.625 49.875 27.1508 49.875 31.5C49.875 35.8492 46.3492 39.375 42 39.375C37.6507 39.375 34.125 35.8492 34.125 31.5Z",
    fill: "#9AAEBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5646 56.1843C27.7 48.3272 34.1109 42 42 42C49.8892 42 56.3002 48.3275 56.4353 56.1849C56.4443 56.706 56.1441 57.183 55.6704 57.4004C51.5072 59.3106 46.8764 60.375 42.0005 60.375C37.1242 60.375 32.493 59.3104 28.3295 57.3998C27.8559 57.1825 27.5557 56.7054 27.5646 56.1843Z",
    fill: "#9AAEBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotaldrivers);
export default __webpack_public_path__ + "static/media/totaldrivers.1de2f6a1dc7661a8b74da588b4e7654b.svg";
export { ForwardRef as ReactComponent };